import { CustomDynamicResultTable } from '@css-xp/base/custom-dynamic-result-table';
import { CustomizeView, HeadCell, SearchResultColumn } from '@css-xp/base';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './invoice-tab-transaction-account.scss';

type ColumnList = HeadCell & SearchResultColumn;

type Props = {
  props: any;
  page: string;
  setColumnList: (columns: ColumnList[]) => void;
  totalCount: number;
  columnsList: ColumnList[];
  label: string;
  isPaginationEnabled?: boolean;
};

const TransactionAccountInvoiceTable = ({
  props,
  page,
  setColumnList,
  totalCount,
  columnsList,
  isPaginationEnabled,
}: Props) => {
  const location = useLocation();
  return (
    <div
      data-testid="transaction-account-ccp-invoice-tab"
      className={classNames('transaction-account-invoice-tab', {
        'transaction-account-invoice-tab-view-all': location.hash !== '#invoices',
      })}
    >
      {page !== 'contacts' ? (
        <CustomDynamicResultTable
          {...props}
          isPaginationEnabled={isPaginationEnabled}
          customiseColumnView={
            <div className={'invoice-view-customize-button'}>
              <CustomizeView
                columns={columnsList}
                columnCount={columnsList?.length}
                updatedColumnView={(record: Array<HeadCell>) => setColumnList([...record] as Array<ColumnList>)}
              />
            </div>
          }
          className={'invoice-transaction-table'}
        ></CustomDynamicResultTable>
      ) : (
        <CustomDynamicResultTable
          {...props}
          className={classNames('invoice-transaction-table', {
            'invoice-transaction-table-no-results': totalCount === 0,
          })}
        ></CustomDynamicResultTable>
      )}
    </div>
  );
};

export default TransactionAccountInvoiceTable;
